import noop from 'lodash/noop';
import React from 'react';
import { createField } from '../helpers';
import type { SelectProps, SelectValue } from '../types';

/**
 * Displays a field as a <select> element.
 */
const SelectField = createField<SelectValue, HTMLSelectElement, SelectProps>(
  ({
    className,
    name = null,
    options = null,
    value = null,
    onValueChange = noop,
    Renderer,
    label,
    error,
    onValueReset,
    onValueSubmit,
    ...props
  }) => (
    <select
      name={name}
      className={`form-control ${className}`}
      value={value}
      onChange={(e) => {
        onValueChange(
          (options.find((o) => `${o.value}` === `${e.currentTarget.value}`) || { value: null }).value,
          value,
          e.currentTarget.name,
          e
        );
      }}
      {...props}
    >
      {options.map(({ label: subLabel, value: subValue }) => (
        <option value={subValue} key={subValue}>
          {subLabel}
        </option>
      ))}
    </select>
  )
);

export default SelectField;
